import script from "./selectGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./selectGoods.vue?vue&type=script&setup=true&lang=js"

import "./selectGoods.vue?vue&type=style&index=0&id=14f2b8c7&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f2b8c7"]])

export default __exports__